import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationAchievements = () => {
  const achievements = [
    {
      id: 1,
      title: 'Total Workouts Completed',
      value: '2,547',
      icon: 'Dumbbell',
      color: 'text-blue-500 bg-blue-500/10',
      trend: '+234 this month'
    },
    {
      id: 2,
      title: 'Community Challenges Won',
      value: '18',
      icon: 'Trophy',
      color: 'text-yellow-500 bg-yellow-500/10',
      trend: '3 active challenges'
    },
    {
      id: 3,
      title: 'Total Calories Burned',
      value: '1.2M',
      icon: 'Flame',
      color: 'text-orange-500 bg-orange-500/10',
      trend: '+45K this week'
    },
    {
      id: 4,
      title: 'Member Satisfaction',
      value: '98%',
      icon: 'Heart',
      color: 'text-red-500 bg-red-500/10',
      trend: 'Based on 156 reviews'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground">Location Achievements</h2>
        <Icon name="Award" size={24} className="text-primary" />
      </div>

      <div className="space-y-4">
        {achievements?.map((achievement) => (
          <div key={achievement?.id} className="flex items-center gap-4 p-4 bg-accent/30 rounded-lg">
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${achievement?.color}`}>
              <Icon name={achievement?.icon} size={24} />
            </div>
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{achievement?.title}</p>
              <p className="text-2xl font-bold text-foreground mb-1">{achievement?.value}</p>
              <p className="text-xs text-muted-foreground">{achievement?.trend}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg border border-primary/20">
        <div className="flex items-center gap-3">
          <Icon name="Sparkles" size={24} className="text-primary" />
          <div>
            <p className="font-semibold text-foreground mb-1">Next Milestone</p>
            <p className="text-sm text-muted-foreground">3,000 total workouts - 453 to go!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationAchievements;